import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import YouTubeButton from './YouTubeButton';
import Footer from './Footer';
import "./Artisti.css";
import { db } from "./firebase";
import { collection, onSnapshot } from "firebase/firestore";
import Icon from "./Icon";
import NavBar from './NavBar';

export default function Artisti() {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [currentArtista, setCurrentArtista] = useState(null);
  const [modalError, setModalError] = useState("");
  const [artists, setArtists] = useState([]);
  const [stepIndex, setStepIndex] = useState(0);
  const [fullscreenOpen, setFullscreenOpen] = useState(false);
  const [fullscreenIdx, setFullscreenIdx] = useState(0);

  // Leggi artisti da Firestore in tempo reale
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "artisti"), (snapshot) => {
      const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      // Ordina prima per 'order' (numerico), poi per createdAt asc; i mancanti vanno in fondo
      list.sort((a, b) => {
        const ao = Number(a.order ?? Number.POSITIVE_INFINITY);
        const bo = Number(b.order ?? Number.POSITIVE_INFINITY);
        if (ao !== bo) return ao - bo;
        const ams = a.createdAt?.toMillis ? a.createdAt.toMillis() : (a.createdAt?.seconds ? a.createdAt.seconds * 1000 : Number.MAX_SAFE_INTEGER);
        const bms = b.createdAt?.toMillis ? b.createdAt.toMillis() : (b.createdAt?.seconds ? b.createdAt.seconds * 1000 : Number.MAX_SAFE_INTEGER);
        return ams - bms;
      });
      setArtists(list);
    });
    return () => unsub();
  }, []);

  // Modal secondario non più usato; usiamo fullscreen diretto

  const openFullscreen = (artist, startIdx = 0) => {
    setCurrentArtista(artist);
    setFullscreenIdx(startIdx);
    setFullscreenOpen(true);
  };
  const closeFullscreen = () => setFullscreenOpen(false);
  const nextFs = () => {
    setFullscreenIdx(i => {
      const total = Math.min(3, currentArtista?.steps?.length || 0); // solo le prime tre immagini
      const next = i + 1;
      if (next >= total) {
        // chiude fullscreen e apre la scheda artista
        setFullscreenOpen(false);
        if (currentArtista?.id) navigate(`/artista/${currentArtista.id}`);
        return i; // inutile, viene chiuso
      }
      return next;
    });
  };
  const prevFs = () => setFullscreenIdx(i => Math.max(0, i - 1));

  const handleClose = () => {
    setModalOpen(false);
    setCurrentArtista(null);
    setStepIndex(0);
    setModalError("");
  };

  return (
    <div className="publicsite-bg">
      {/* Quick access to Dashboard in top-right, consistent with Home */}
      <Link to="/login" className="dash-badge">Dashboard</Link>
      <div className="logo-wrapper">
        <div className="logo-stack">
          <img src="/disco.png" alt="Disco" className="disco-img" />
          <img src="/logo.png" alt="Logo Arte Registrazioni" className="logo-img" />
        </div>
      </div>
      <NavBar />
      
      <section className="gallery">
        {artists.length === 0 ? (
          <p style={{ color: "#ffd700", textAlign: "center" }}>Nessun artista disponibile.</p>
        ) : (
          artists.map((artist) => (
            <div className="artist-photo" key={artist.id}>
              <img
                src={artist.steps && artist.steps[0] ? artist.steps[0] : artist.photo || "/logo.png"}
                alt={artist.nome}
                tabIndex={0}
                onClick={() => openFullscreen(artist, 0)}
                style={{ cursor: "pointer", width: 220, height: 275, objectFit: "cover", borderRadius: 12, boxShadow: "0 0 12px #ffd700" }}
              />
              {/* Niente nome sotto: la foto contiene già il nome */}
            </div>
          ))
        )}
      </section>
      {modalOpen && currentArtista && (
        <div
          id="modal"
          className="show"
          style={{
            display: "flex",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.98)",
            zIndex: 9999,
            justifyContent: "center",
            alignItems: "center",
          }}
          role="dialog"
          aria-modal="true"
        >
          <div style={{ background: "#222", borderRadius: 16, padding: 24, boxShadow: "0 0 32px #ffd700", minWidth: 320 }}>
            {/* Steps images navigation (modal secondaria, non fullscreen principale) */}
            {currentArtista.steps && currentArtista.steps.length > 0 && currentArtista.steps[stepIndex] ? (
              <img
                id="modal-img"
                src={currentArtista.steps[stepIndex]}
                alt={currentArtista.nome}
                style={{
                  maxWidth: "90vw",
                  maxHeight: "60vh",
                  borderRadius: "16px",
                  boxShadow: "0 0 32px #ffd700, 0 0 16px #fff",
                  background: "#222",
                  display: "block",
                  animation: "pulse-glow 1.2s infinite",
                  marginBottom: 18
                }}
                onError={() => setModalError("Immagine non trovata")}
                onLoad={() => setModalError("")}
              />
            ) : (
              <img
                id="modal-img"
                src={currentArtista.photo || "/logo.png"}
                alt={currentArtista.nome}
                style={{
                  maxWidth: "90vw",
                  maxHeight: "60vh",
                  borderRadius: "16px",
                  boxShadow: "0 0 32px #ffd700, 0 0 16px #fff",
                  background: "#222",
                  display: "block",
                  animation: "pulse-glow 1.2s infinite",
                  marginBottom: 18
                }}
                onError={() => setModalError("Immagine non trovata")}
                onLoad={() => setModalError("")}
              />
            )}
            {/* Steps navigation buttons */}
            {currentArtista.steps && currentArtista.steps.length > 1 && (
              <div style={{ display: "flex", justifyContent: "center", gap: 16, marginBottom: 12 }}>
                <button
                  style={{ background: "#222", color: "#ffd700", border: "1px solid #ffd700", borderRadius: 6, padding: "4px 14px", fontWeight: "bold", cursor: "pointer" }}
                  disabled={stepIndex === 0}
                  onClick={() => setStepIndex(i => Math.max(0, i - 1))}
                >
                  &lt;
                </button>
                <span style={{ color: "#ffd700", fontWeight: "bold" }}>{stepIndex + 1} / {currentArtista.steps.length}</span>
                <button
                  style={{ background: "#222", color: "#ffd700", border: "1px solid #ffd700", borderRadius: 6, padding: "4px 14px", fontWeight: "bold", cursor: "pointer" }}
                  disabled={stepIndex === currentArtista.steps.length - 1}
                  onClick={() => setStepIndex(i => Math.min(currentArtista.steps.length - 1, i + 1))}
                >
                  &gt;
                </button>
              </div>
            )}
            {/* Rimuovo nome sotto la foto nel modal principale */}
            {currentArtista.albums && currentArtista.albums.length > 0 && (
              <div>
                <h4 style={{ color: "#ffd700", textAlign: "center" }}>Dischi / Cover</h4>
                <ul style={{ listStyle: "none", padding: 0 }}>
                  {currentArtista.albums.map((album, idx) => (
                    <li key={idx} style={{ background: "#111", borderRadius: 10, marginBottom: 12, padding: 12, boxShadow: "0 0 8px #ffd700" }}>
                      {album.cover && (
                        <img src={album.cover} alt={album.title} style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8, boxShadow: "0 0 6px #ffd700", marginBottom: 8 }} />
                      )}
                      <div style={{ color: "#ffd700", fontWeight: "bold" }}>{album.title}</div>
                      <div style={{ color: "#fff" }}>Anno: {album.year} | Genere: {album.genre}</div>
                      {/* Semplice player audio se esiste un pulsante Play con link valido */}
                      {(() => {
                        try {
                          const playBtn = album.buttons && album.buttons.find(b => (b.name || "").toLowerCase() === "play" && b.link);
                          if (!playBtn) return null;
                          // Mostra player; evita di mostrare anche il pulsante Play duplicato sotto
                          return (
                            <div style={{ marginTop: 8 }}>
                              <audio
                                controls
                                preload="none"
                                style={{ width: "100%", maxWidth: 360 }}
                                src={playBtn.link}
                                onError={(e) => {
                                  console.warn("Errore caricamento audio", playBtn.link, e);
                                }}
                              >
                                Il tuo browser non supporta l'elemento audio.
                              </audio>
                            </div>
                          );
                        } catch (err) {
                          console.warn("Errore rendering player", err);
                          return null;
                        }
                      })()}
                      <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
                        {/* Priorità: Stripe Payment Link se presente, altrimenti PayPal Hosted Button; altrimenti pulsanti standard */}
                        {album.paymentLinkUrl ? (
                          <a href={album.paymentLinkUrl} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#ffd700', color: '#222', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontWeight: 'bold' }}>
                            <Icon name="Download" size={18} />
                            Buy & Download (Album)
                          </a>
                        ) : album.paypalHostedButtonId ? (
                          <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top" style={{ display: 'inline-flex' }}>
                            <input type="hidden" name="cmd" value="_s-xclick" />
                            <input type="hidden" name="hosted_button_id" value={album.paypalHostedButtonId} />
                            <input type="hidden" name="currency_code" value="EUR" />
                            <input type="hidden" name="custom" value={`${currentArtista?.id || ''}:${idx}`} />
                            <input type="hidden" name="return" value={(typeof window !== 'undefined' ? window.location.origin : '') + `/download-confirm?cm=${encodeURIComponent(`${currentArtista?.id || ''}:${idx}`)}` } />
                            <input type="hidden" name="cancel_return" value={(typeof window !== 'undefined' ? window.location.origin : '') + '/artisti'} />
                            <button type="submit" title="Paga con PayPal" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: '#ffd700', color: '#222', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontWeight: 'bold' }}>
                              <Icon name="Download" size={18} />
                              Buy & Download (Album)
                            </button>
                          </form>
                        ) : (
                          // Altrimenti, rendi gli altri pulsanti normalmente (Spotify/YouTube/Apple/Download custom)
                          (album.buttons || [])
                            .filter(btn => (btn.name || "").toLowerCase() !== "play")
                            .map((btn, bidx) => (
                              btn.link ? (
                                <a key={bidx} href={btn.link} target={((btn.name || '').toLowerCase().includes('download')) ? "_self" : "_blank"} rel="noopener noreferrer" style={{ color: "#ffd700", background: ((btn.name || '').toLowerCase().includes('download')) ? "#ffd700" : "#222", borderRadius: 6, padding: "2px 8px", marginRight: 2, textDecoration: "none", fontSize: "0.95em", display: 'inline-flex', alignItems: 'center', gap: 4, ...( (btn.name || '').toLowerCase().includes('download') ? { color: '#222', fontWeight: 'bold' } : {} ) }}>
                                  <Icon name={btn.name} size={18} />
                                  <span>{btn.name}</span>
                                </a>
                              ) : null
                            ))
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {modalError && (
              <div
                id="modal-error"
                style={{
                  color: "#ffd700",
                  fontSize: "1.2em",
                  textAlign: "center",
                  marginTop: "20px"
                }}
              >
                {modalError}
              </div>
            )}
            <button
              style={{
                marginTop: 18,
                background: "none",
                border: "none",
                color: "#ffd700",
                fontSize: "2em",
                cursor: "pointer",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto"
              }}
              onClick={handleClose}
              aria-label="Chiudi"
            >
              &times;
            </button>
          </div>
        </div>
      )}

      {/* Fullscreen viewer con mano luminosa e senza testo/frecce */}
      {fullscreenOpen && currentArtista && (
        <div className="fullscreen-backdrop" onClick={closeFullscreen}>
          <img
            src={currentArtista.steps && currentArtista.steps[fullscreenIdx] ? currentArtista.steps[fullscreenIdx] : currentArtista.photo || "/logo.png"}
            alt=""
            className="fullscreen-img"
            onClick={(e) => e.stopPropagation()}
          />
          {currentArtista.steps && currentArtista.steps.length > 1 && (
            <>
              <button className="hand-button hand-left" aria-label="precedente" onClick={(e) => { e.stopPropagation(); prevFs(); }}>
                <Icon name="Hand" size={28} color="#00FFFF" />
              </button>
              <button className="hand-button hand-right" aria-label="successiva" onClick={(e) => { e.stopPropagation(); nextFs(); }}>
                <Icon name="Hand" size={28} color="#00FFFF" />
              </button>
            </>
          )}
        </div>
      )}
      <div className="youtube-under-menu">
        <YouTubeButton small layout="row" />
      </div>
      <Footer />
    </div>
  );
}